import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import { Down } from 'patternx-svg';

interface IStateAddBtn {
  // onAdd: Function;
  menuClick: (key: any) => void;
}

export default React.memo((props: IStateAddBtn) => {
  return (
    <Dropdown
      overlay={
        <Menu onClick={props.menuClick}>
          <Menu.Item key="normal">添加构件</Menu.Item>
          <Menu.Item key="gmodeler">添加正向构件</Menu.Item>
        </Menu>
      }
      placement="bottom"
    >
      <Button type="primary">
        <div className="center">
          <span style={{ margin: '0 10px' }}>添加构件</span>
          <Down width={16} height={16} />
        </div>
      </Button>
    </Dropdown>
  );
});
